import axios from "axios"


export const rootUrl = axios.create ({baseURL:"https://erp.apitco.org:8092",})
//export const rootUrl = axios.create ({baseURL:"http://192.168.4.192:8092",})

export const APP_BASE_URL = "https://tms.apitco.org";